import { Resources } from 'constants/resources';

import { useMemo } from 'react';

import { useGetMany } from 'react-admin';
import { Gateway } from 'types/embedded/gateway';
import { getGatewayCurrencyIds } from 'utils/getGatewayCurrencyIds';

export const useGatewaysCurrencyIds = (gatewayIds: string[] = []): string[] => {
  const { data: gateways = [] } = useGetMany<Gateway>(
    Resources.Gateways,
    { ids: gatewayIds },
    { enabled: gatewayIds.length > 0 },
  );

  return useMemo(() => Array.from(new Set(gateways.flatMap(getGatewayCurrencyIds))), [gateways]);
};
